import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { FC, PropsWithChildren } from 'react';
import { NavPage } from '../breadcrumbs/Breadcrumbs';

interface CataloguePageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbs: NavPage[];
}

export const CataloguePageHeader: FC<PropsWithChildren<CataloguePageHeaderProps>> = ({
  breadcrumbs,
  title,
  subtitle,
  children
}) => {
  return (
    <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
      <div className="flex justify-between gap-5 items-center font-bold">
        <div className="flex gap-4 items-center">
          <h2 className="text-3xl font-bold tracking-tight">{title}</h2>
          {subtitle && (
            <>
              <div className="h-2 w-2 bg-gray-400 rounded-full"></div>
              <h2 className="text-3xl text-gray-500 tracking-tight">{subtitle}</h2>
            </>
          )}
        </div>
        {children}
      </div>
    </BreadcrumbPageHeader>
  );
};
